import axios from "axios";
import Swal from "sweetalert2";

/* Default axios object */
const axiosClient = axios.create();
axiosClient.defaults.baseURL = "https://europe-west3-pim-sandbox.cloudfunctions.net/pimapi/V1.0";
axiosClient.defaults.timeout = 20000;

export default axiosClient;
